<template lang="pug">
.consumer-line-card
    md-card(md-with-hover)
        md-card-media-cover(md-text-scrim)
            md-card-media(md-ratio="16:9")
                img(src="/static/img/cavalor-consumer-line.png")
            md-card-area
                md-card-header
                    .md-title Te Weinig Energie
        md-card-actions
            span(style="flex:1;")
            md-button.md-flat.md-accent#action(@click.native="expert=true" style="color: #012C58;") Ask the Expert
    ask-low-energy(:show.sync="expert" :step="2")</template>
<script>

export default {
  components: {
    AskLowEnergy: () => import('@/components/AskLowEnergy')
  },
  data: () => {
    return {
      expert: false
    }
  }
}
</script>
<style scoped>
.md-card {
    margin: 0px;
}
button#action:hover {
  border-width: 1px;
  border-color: #012c58;
  border-style: solid;
}
</style>



// WEBPACK FOOTER //
// src/components/LowEnergyCard.vue